import { render } from "./select-searchable.vue?vue&type=template&id=64344db5"
import script from "./select-searchable.vue?vue&type=script&lang=js"
export * from "./select-searchable.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./select-searchable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__